import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/logo.png" alt="Cakified Logo" />
              <h3>Cakified</h3>
            </div>
            <p className="footer-tagline">
              Handcrafted with love, baked fresh daily. Experience the art of premium desserts.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><button onClick={() => scrollToSection('chocolate-cakes')}>Chocolate Cakes</button></li>
              <li><button onClick={() => scrollToSection('pineapple-cakes')}>Pineapple Cakes</button></li>
              <li><button onClick={() => scrollToSection('customized-cakes')}>Customized Cakes</button></li>
              <li><button onClick={() => scrollToSection('jar-cakes')}>Jar Cakes</button></li>
              <li><button onClick={() => scrollToSection('brownies')}>Brownies</button></li>
              <li><Link to="/about">About Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Our Promise</h4>
            <ul className="footer-features">
              <li>✨ Premium Quality Ingredients</li>
              <li>🎂 Fresh & Made to Order</li>
              <li>💝 Handcrafted with Care</li>
              <li>📦 Secure Packaging</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Get in Touch</h4>
            <div className="footer-contact">
              <p>📱 WhatsApp Orders</p>
              <p>📧 nashrarif04@gmail.com</p>
              <p>⏰ 9:00 AM - 8:00 PM</p>
            </div>
            <div className="footer-social">
              <a href="https://www.facebook.com/nashra.siddiqui.37" aria-label="Facebook" target="_blank">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/cakified.n/" aria-label="Instagram" target="_blank">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" fill="white"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="white" strokeWidth="2"/>
                </svg>
              </a>
              <a href="#" aria-label="Twitter">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Cakified. All rights reserved.</p>
          <p className="footer-credits">Made with ❤️ for sweet moments</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
